import * as React from "react";
import { StyleSheet, View } from "react-native";
import { RewardsIntroSplashScreen } from "../../components/new/rewrds-intro-splash-screen/rewrds-intro-splash-screen";
import { useNavigation } from "@react-navigation/native";
import { RewardsIntroImageStep2 } from "../../../assets/rewards-intro-image-step-2";
import { translate } from "../../i18n/translate";
import automationTestingLocators from "./utils/automation-testing-locators.json";

export const RewardsIntroSplashScreenStep2 = () => {
  const navigation = useNavigation();

  return (
    <RewardsIntroSplashScreen
      stepTitle={translate("rewardsIntroSplashScreen.step2.stepTitle") as string}
      stepDescription={translate("rewardsIntroSplashScreen.step2.stepDescription") as string}
      totalNumberOfSteps={3}
      currentStep={2}
      onPressNext={() => navigation.navigate("RewardsIntroSplashScreenStep3")}
      onPressPrevious={() => navigation.navigate("RewardsIntroSplashScreenStep1")}
      {...automationTestingLocators.rewardsIntroSplashScreenStep2.rewardsIntroSplashScreenStep2}>
      <View style={{ height: 243, width: "100%" }}>
        <RewardsIntroImageStep2
          width={"100%"}
          height={"100%"}
          {...automationTestingLocators.rewardsIntroSplashScreenStep2
            .rewardsIntroSplashScreenStep2Image}
        />
      </View>
    </RewardsIntroSplashScreen>
  );
};

const styles = StyleSheet.create({});
